var _rect, _path, _path2, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 16,
    height: 14,
    rx: 2,
    fill: "white",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 11.2044 7.68393 10.4413 7.12132 9.87868C6.55871 9.31607 5.79565 9 5 9C4.20435 9 3.44129 9.31607 2.87868 9.87868C2.31607 10.4413 2 11.2044 2 12H8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.99672C6.99812 4.89158 6.10037 3.99738 4.99522 4.00001C3.89195 4.0015 2.99888 4.89682 3 5.99991C3 7.10505 3.89644 8.00075 5.00159 8C6.10674 7.99906 7.00168 7.10187 7 5.99672Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 5.5,
    x2: 13.5,
    y2: 5.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 7.5,
    x2: 13.5,
    y2: 7.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 9.5,
    x2: 12.5,
    y2: 9.5,
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/membership.118f6022.svg";
export { ForwardRef as ReactComponent };